

define(['angular', 'squid/index', 'components/xo-wallet-components/src/add-card/route', './directive'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('hermes.page.xo-add-card.route', ['squid', 'xo-add-card.route', 'hermes.page.xo-add-card.directive']).factory('$AddCardPageRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('AddCardPageRoute', {
            name: 'pageAddCard',
            directive: 'xo-page-add-card-page',
            titleContent: 'asideHeader.addCard',
            query: ['gaming', 'country', 'fiType', 'mode'],
            trackingData: {
                templateName: 'addCard.dust',
                pageGoal: 'Add Card',
                buzname: {
                    'fullpage': {
                        'pagename': '%::fullpage-add-cc',
                        'pagename2': '%::fullpage-add-cc:guest:hermes:',
                        'version': 'guest:%:'
                        // More page qualifiers come here...
                    } }
            },
            children: [{
                name: '$AddCardFlowRoute',
                attributes: {
                    token: 'token',
                    message: 'message',
                    pagetitle: 'pagetitle',
                    'parent-callbacks': 'callbacks'
                }
            }]
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./pages/xo-add-card/route.js
// module id = ./pages/xo-add-card/route.js
// module chunks = 1